import React, { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { getPriceList, updatePriceList, reorderPriceListItem } from '../../../actions/priceModel'

// import styles
import './extras.scss'

// Utils
import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
import {
  createConfigContext,
  getServicesConfig,
  getExtrasConfig
} from './config'
import { translation } from '../../../utils/helpers'

// Components
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'
import PriceItemGroup from '../PriceItemGroup'

// Elements
import Col from '../../../shared/elements/col'
import Inline from '../../../shared/elements/inline'
import Switch from '../../../shared/elements/switch'

class Extras extends Component {

  constructor (props) {
    super(props)
    this.state = {
      price: {},
      ConfirmShow: {
        UseRecommended: false
      },
      isBodyShop: false
    }
    this.switchRecommended = this.switchRecommended.bind(this)
    this.loadPriceModel = this.loadPriceModel.bind(this)
    this.moveItem = this.moveItem.bind(this)
    this.getItemListName = this.getItemListName.bind(this)
    this.getItemIdField = this.getItemIdField.bind(this)
    this.updateOrAddItem = this.updateOrAddItem.bind(this)
    this.deleteItem = this.deleteItem.bind(this)
  }

  componentDidMount () {
    this.loadPriceModel(this.props)
  }

  componentWillUpdate (nextProps) {
    if (this.props.item.PriceModelId !== nextProps.item.PriceModelId) {
      this.loadPriceModel(nextProps)
    }
  }

  loadPriceModel (props) {
    this.setState({
      price: {},
      ConfirmShow: {
        UseRecommended: false
      }
    }, () => {
      this.props.getPriceList(props.item.PriceModelId).then((res) => {
        this.setState({
          price: res.data,
          isBodyShop: res.data.Department === 1
        })
      }, () => {
        // Toastr
        window.toastr.error(translation('13445'), translation('216'))
        this.props.router.push('/prices')
      })
    })
  }

  deleteItem (item) {
    item.IsDeleted = true
    this.updateOrAddItem(item)
  }

  moveItem (item, newPosition) {
    if (item.SortIndex === undefined) return // Need sort index to make reordering work.
    let oldSortIndex = item.SortIndex

    let listName = this.getItemListName(item)
    let idField = this.getItemIdField(item)
    let price = { ...this.state.price }
    let hasPartId = item.PartItemId !== undefined
    let hasPartItem = item.PartItem !== undefined && item.PartItem.PartItemId !== undefined
    let list = price[listName]
    item.SortIndex = newPosition
    this.setState({ IsWorking: true })
    this.props.reorderPriceListItem(item).then(res => {
      // Assign sortindex from result to all items
      for (let i = 0; i < res.data.length; i++) {
        let listItem = list.find(li => li[idField] === res.data[i][idField])
        if (listItem !== undefined) {
          listItem.SortIndex = res.data[i].SortIndex
        }
      }
    }, () => {
      // If reorder failed on server, revert to old position.
      item.SortIndex = oldSortIndex

      // show error toast
    }).finally(() => {
      // Sort list containing item, to make sure the list and visual dom matches.
      const sorter = (a, b) => {
        if (hasPartId) {
          if (a.PartItemId !== b.PartItemId) return a.PartItemId - b.PartItemId
        } else if (hasPartItem) {
          if (a.PartItem.PartItemId !== b.PartItem.PartItemId) return a.PartItem.PartItemId - b.PartItem.PartItemId
        }
        return a.SortIndex - b.SortIndex
      }

      if (list !== null) {
        list = list.sort((a, b) => sorter(a, b))
        price[listName] = list
        this.setState({
          price: price,
          IsWorking: false
        })
        // console.log('updated list', list.filter((a) => a.SortIndex !== null).map(i => { return { Id: i[this.getItemIdField(i)], TaskName: i.TaskName, SortIndex: i.SortIndex, PartItemId: (hasPartId ? i.PartItemId : i.PartItem.PartItemId) } }))
      }
    })
  }

  updateOrAddItem (item, doPost = true) {
    let idField = this.getItemIdField(item)
    let listName = this.getItemListName(item)
    if (listName === null || idField === null) {
      console.error('Could not update or add item!', item)
      return
    }

    // console.log('Updating item', item, 'adding to ', listName, '(id ' + item[idField] + ')')
    let price = {...this.state.price}
    let list = price[listName]
    if (item[idField] > 0) {
      for (var i; i < list.length; i++) {
        let oldItem = list[i]
        if (oldItem[idField] === item[idField]) {
          list[i] = item
          // updated = true
          break
        }
      }
    } else {
      item[idField] = 0
      list.push(item)
    }
    price[listName] = list

    // Finally send to api.
    if (doPost) {
      this.updatePrices(price)
    }
  }

  getItemIdField (item) {
    // Find id field
    var idFields = []
    var fields = Object.keys(item)
    for (let f in fields) {
      let field = fields[f]
      if (field.toLowerCase().endsWith('id')) {
        idFields.push(field)
      }
    }

    // Determine correct id field.
    for (let f in idFields) {
      if (item[idFields[f]] === undefined || item[idFields[f]] === null || !(typeof item[idFields[f]] === 'number')) continue
      switch (idFields[f].toLowerCase()) {
        case 'servicetaskid':
          return idFields[f]
      }
    }
    console.error('Could not determine Id field of item!', item)
    return null
  }

  getItemListName (item) {
    // Find id field
    var idFields = []
    var fields = Object.keys(item)
    for (let f in fields) {
      let field = fields[f]
      if (field.toLowerCase().endsWith('id')) {
        idFields.push(field)
      }
    }
    // console.log('getItemListName id fields', idFields)
    // Determine correct id field.
    for (let f in idFields) {
      if (item[idFields[f]] === undefined || item[idFields[f]] === null || !(typeof item[idFields[f]] === 'number')) continue
      switch (idFields[f].toLowerCase()) {
        case 'servicetaskid':
          return 'ServiceTasks'
      }
    }

    console.error('Could not determine List name of item!', item)
    return null
  }

  updatePrices (price) {
    this.setState({ IsWorking: true })
    this.props.updatePriceList(price).then((res) => {
      this.setState({
        price: res.data,
        IsWorking: false
      })
      // Toastr
      // window.toastr.success(translation('13444'), translation('13424'))
    }, () => {
      // Toastr
      this.setState({ IsWorking: false })
      window.toastr.error(translation('13445'), translation('216'))
      this.props.router.push('/prices')
    })
  }

  onlyShow () {
    if (this.state.price.UseRecommended) {
      if (hasAccess([1, 4], this.props.auth.user.UserType)) {
        return false
      }
      return true
    }
    return false
  }

  switchRecommended (e) {
    let value = (e.target.checked)
    let price = { ...this.state.price }
    price.UseRecommended = value
    this.setState({ price: price })
    if (value === true) {
      this.ToggleConfirmShow('UseRecommended', true)
    } else {
      this.updatePrices(price)
    }
  }

  renderRecommendedSelector () {
    if (!hasAccess([3, 7], this.props.auth.user.UserType) || (!hasSubscriptionPermission(this.props.auth, 10, 0) && !this.props.customer)) return null
    if (parseInt(this.props.auth.user.ShopId, 10) !== this.state.price.ShopId) return null
    // Recommended text
    const recommendedText = () => {
      let translationText = translation('13474')
      console.log('[Extras] recommendedText', this.props)
      if (this.props.customer) {
        return translationText.replace('[NAME]', this.props.auth.user.ShopName)
      }
      return translationText.replace('[NAME]', this.props.auth.user.ChainName)
    }

    // Return
    return (
      <Inline>
        <span>{recommendedText()}</span>
        <Switch name='UseRecommended' onChange={this.switchRecommended} checked={this.state.price.UseRecommended} />
      </Inline>
    )
  }

  ToggleConfirmShow (id, value) {
    let currentVal = this.state.ConfirmShow[id]
    if (currentVal === undefined) currentVal = false
    let confirmState = this.state.ConfirmShow
    confirmState[id] = (value !== undefined && value !== null) ? value : !currentVal
    this.setState({ ConfirmShow: confirmState })
  }

  render () {
    // Test comment
    const renderConfirmRecommendedSetting = () => {
      const confirm = () => {
        this.ToggleConfirmShow('UseRecommended', false)
        // update
        this.updatePrices(this.state.price)
      }

      const notConfirm = () => {
        this.ToggleConfirmShow('UseRecommended', false)
        // set radio back
        let price = this.state.price
        price.UseRecommended = false
        this.setState({ price: price })
      }

      let confirmText = this.props.customer ? translation('13010').replace('{0}', '') : translation('13010').replace('{0}', this.props.auth.user.ChainName)
      return (this.state.ConfirmShow.UseRecommended && (
        <Portal className='deleteModal' onPortalClose={this.ToggleConfirmShow.bind(this, 'UseRecommended', false)}>
          <Confirm renderText={() => { return confirmText }} confirm={confirm.bind(this)} notConfirm={notConfirm.bind(this)} />
        </Portal>
      )
      )
    }

    if (Object.keys(this.state.price).length === 0) return null
    let { price } = this.state
    let currentUserIsCustomer = this.props.auth.user.UserType === 4
    let showExtras = this.props.showExtras !== undefined ? this.props.showExtras : true
    let showServices = this.props.showServices !== undefined ? this.props.showServices : true
    let isOnlyPaint = this.props.auth.departmentType === 0

    const renderServices = () => {
      let items = price.ServiceTasks.filter(x => !x.IsExtra)
      return (
        <PriceItemGroup
          items={items}
          itemClass='extras'
          config={getServicesConfig(createConfigContext(this.props.auth, this.state.price))}
          onAdd={this.updateOrAddItem}
          onDelete={this.deleteItem}
          onUpdate={this.updateOrAddItem}
          onDragged={this.moveItem}
          disabled={this.state.IsWorking}
          groupId={false} />
      )
    }

    const renderExtras = () => {
      let items = price.ServiceTasks.filter(x => x.IsExtra)
      return (
        <PriceItemGroup
          items={items}
          itemClass='extras'
          config={getExtrasConfig(createConfigContext(this.props.auth, this.state.price))}
          onAdd={this.updateOrAddItem}
          onDelete={this.deleteItem}
          onUpdate={this.updateOrAddItem}
          onDragged={this.moveItem}
          disabled={this.state.IsWorking}
          groupId />
      )
    }

    const renderExtrasShow = () => {
      let items = price.ServiceTasks.filter(x => x.IsExtra)
      return (
        <PriceItemGroup
          items={items}
          itemClass='extras'
          config={getExtrasConfig(createConfigContext(this.props.auth, this.state.price))}
          onAdd={this.updateOrAddItem}
          onDelete={this.deleteItem}
          onUpdate={this.updateOrAddItem}
          onDragged={this.moveItem}
          disabled={this.state.IsWorking}
          groupId />
      )
    }

    return (
      <div className='extras__screen'>
        <Col span='3'>
          {this.renderRecommendedSelector()}
          {isOnlyPaint && currentUserIsCustomer && showServices && renderServices()}
          {!currentUserIsCustomer && showExtras && renderExtras()}
          {currentUserIsCustomer && showExtras && renderExtrasShow()}
          {renderConfirmRecommendedSetting()}
        </Col>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getPriceList,
  updatePriceList,
  reorderPriceListItem
})(Extras)



// WEBPACK FOOTER //
// ./src/app/pages/Prices/Extras/index.js